<template>
    <div class="panel panel-default">
        <div class="panel-heading separator">
            <div class="panel-title">
                <h3>Réservations</h3>
                <div class="panel-choose-view">
                    <button
                        @click.prevent="view = 'calendar'"
                        :style="view === 'calendar' ? { color: '#fff',backgroundColor: '#fc7795', borderColor: '#fc7795' } : ''"
                        class="btn btn-complete btn-sm">Voir le calendrier
                    </button>
                    <button
                        @click.prevent="view = 'list'"
                        :style="view === 'list' ? { color: '#fff',backgroundColor: '#fc7795', borderColor: '#fc7795' } : ''"
                        class="btn btn-complete btn-sm">Voir la liste
                    </button>
                </div>
            </div>
        </div>
        <div v-show="view === 'list'" class="panel-body scrollable">
            <div class="locations-upcoming-reservations">
                <div class="table-responsive">
                    <div id="basicTable_wrapper" class="dataTables_wrapper form-inline no-footer">
                        <table class="table table-hover dataTable no-footer" id="basicTable" role="grid">
                            <tbody>
                                <tr v-if="filteredBookings.length === 0">
                                    <td>
                                        <p class="text-center">Aucune réservation ne correspond à ces critères.</p>
                                    </td>
                                </tr>
                                <one-time-locations-upcoming-reservations-item
                                    v-for="(booking, index) in filteredBookings"
                                    :key="index"
                                    :booking="booking"
                                    @click.native="openQuickView(booking)"
                                    :data-toggle="dataToggleQuickview(booking)"
                                    data-toggle-element="#booking__panel">
                                </one-time-locations-upcoming-reservations-item>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <calendar v-if="view === 'calendar'" :filteredBookings="filteredBookings" :filteredBookingsForWorkingHours="filteredBookingsForWorkingHours"></calendar>
        <div class="quickview-wrapper" id="booking__panel">
            <div class="view-port clearfix" id="eventFormController">
                <div class="view bg-white">
                    <div class="scroll-wrapper scrollable">
                        <div class="p-l-30 p-r-30 p-t-20">
                            <a class="pg-close text-master link pull-right"
                                @click="closeCancelForm"
                                data-toggle="quickview"
                                data-toggle-element="#booking__panel"
                                href="#">
                            </a>
                            <h4 id="event-date"> Réservation N°{{ reservationID }}</h4>
                            <div class="m-b-20">
                                <!-- <i class="fa fa-clock-o"></i> -->
                                <span id="lblfromTime">Du {{ startDate }} à {{ startHour }}</span>
                                <br>
                                <span id="lbltoTime">Au {{ endDate }} à {{ endHour }}</span>
                            </div>
                            <div class="m-b-20" v-if="cancelledBooking">
                                <span class="label label-success">Annulée le {{ cancelledBooking }}</span>
                            </div>
                        </div>
                        <div class="p-t-15">
                            <input id="eventIndex" name="eventIndex" type="hidden" value="2">
                            <div class="form-group-attached">
                                <div class="form-group form-group-default ">
                                    <label>Nom du client</label>
                                    <span class="form-control">{{ customerName }}</span>
                                </div>
                                <div class="row clearfix">
                                    <div class="form-group form-group-default">
                                        <label>Bureau</label>
                                        <span class="form-control">{{ officeName }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-l-30 p-r-30 p-t-30 button__wrapper">
                            <div class="info" v-show="displayCancelForm">Merci de sélectionner la date et l'heure de la réception de la demande d'annulation : <div>(ceci va déterminer le taux de remboursement à appliquer en fonction des CGV).</div></div>
                            <div v-show="displayCancelForm" id="datepicker" :data-date="nowDate"></div>
                            <div v-show="displayCancelForm" class="input-group bootstrap-timepicker">
                                <input id="timepicker" type="text" class="form-control">                                
                            </div>

                            <div v-show="displayCancelForm" class="input-group m-t-20">
                                <label for="cancelledWithComment">Commentaire</label>                                
                                <textarea v-model="cancelledWithComment" class="form-control" name="cancelledWithComment" rows="3"></textarea>
                            </div>

                            <button v-if="cancelledBooking == 0 && !displayCancelForm && userIsAuthorized" @click="showCancelForm" class="btn btn-warning"><i
                                    class="fa fa-trash-o"></i>Annuler la réservation</button>
                            <div v-if="errorMessage" class="label label-important">{{ errorMessage }}</div>
                            <button v-if="displayCancelForm" @click="validateCancelDate(reservationID)" class="btn btn-warning"><i
                                    class="fa fa-trash-o"></i>Confirmer l'annulation</button>
                            <button v-if="cancelledBooking != 0 && isRestorable" @click="restoreBooking(reservationID)"
                                class="btn btn-complete">Rétablir la réservation</button>
                            <button @click="redirectToOrder" class="btn btn-complete">Voir la commande</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.panel-title {
    display: flex !important;
    justify-content: space-between;
    align-items: center;

    button {
        height: 35px;
    }
}
.label {
    white-space: normal;
    padding: 10px;
    margin: 30px 0px 10px;
    line-height: 20px;
}

.locations-upcoming-reservations {
    margin: 15px 0 0 0;
    min-width: 300px;
}

.button__wrapper {
    display: flex;
    flex-direction: column;

    .btn {
        margin: 20px 0;
    }

    .info {
        white-space: normal;
        font-size: 13px;
    }
}

.panel-choose-view {
    padding: 20px;
    display: flex;
    justify-content: flex-end;

    button {
        &:first-child {
            margin-right: 10px;
        }
    }
}

#booking__panel {
    width: 525px;
    right: -525px;
    .datepicker-inline {
        width: 270px;
        margin: 0 auto;
    }
}
</style>

<script type="text/babel">
import Calendar from './Calendar'
import OneTimeLocationsUpcomingReservationsItem from './OneTimeLocationsUpcomingReservationsItem'
import {
    mapState,
    mapGetters,
    mapActions
} from 'vuex'
import axios from 'axios'

export default {
    data() {
        return {
            view: 'calendar',
            reservationID: 0,
            startDate: null,
            endDate: null,
            startHour: null,
            endHour: null,
            customerName: '',
            customerID: 0,
            officeName: '',
            cancelledBooking: false,
            selectedOrder: '',
            booking: null,
            displayCancelForm: false,
            cancelDay: null,
            cancelTime: null,
            errorMessage: null,
            cancelledWithComment: null,
            userIsAuthorized: null,
        }
    },
    components: {
        Calendar,
        OneTimeLocationsUpcomingReservationsItem
    },
    mounted() {
        // this.fetchBookings(this.searchFilters.agenciesID)
        $('#datepicker').datepicker({
            format: 'dd-mm-yyyy',
            language: "fr"
        }).on('changeDate', (e) => {
            this.cancelDay = moment(e.date)
        })

        $('#timepicker').timepicker({
            showMeridian: false,
            maxHours: 24,
            minuteStep: 1
        }).on('change', (e) => {
            this.cancelTime = moment.duration(e.target.value)
        })
    },
    methods: {
        ...mapActions('bookings', [
            'fetchBookings',
            'fetchPunctualUnavailabiliy'
        ]),
        openQuickView (booking) {
            if (!_.has(booking, 'reason')) {
                this.reservationID = booking.id
                this.startDate = moment(booking.start_date).format('Do MMMM YYYY')
                this.endDate = moment(booking.end_date).format('Do MMMM YYYY')
                this.startHour = moment(booking.start_date).format('HH:mm')
                this.endHour = moment(booking.end_date).format('HH:mm')
                this.customerName = booking.suborder.suborderable.customer.name
                this.customerID = booking.suborder.suborderable.customer_id
                this.officeName = booking.suborder.text
                this.cancelledBooking = booking.cancelled_at === null ? 0 : moment(booking.cancelled_at).format('DD/MM/YYYY à HH:mm')
                this.selectedOrder = booking.suborder.suborderable.id
                this.booking = booking

                let userIsAuthorized = true
                let endDate = moment(booking.end_date)
                let now = moment()

                if (!this.me.admin && endDate.isBefore(now.clone().subtract(7, 'days'))) {
                    userIsAuthorized = false
                }
                
                this.userIsAuthorized = userIsAuthorized
            }
        },
        dataToggleQuickview (booking) {
            return _.has(booking, 'reason') ? '' : 'quickview'
        },
        redirectToOrder () {
            this.$store.commit('customer/HIGHLIGHT_ORDER', this.selectedOrder)
            this.$store.commit('tabs/customer/TAB_ACTIVATION', 1)
            this.$router.push({
                name: 'customer',
                params: {
                    id: this.customerID
                }
            })
        },
        showCancelForm () {
            this.displayCancelForm = true
            this.cancelDay = moment().format('YYYY-MM-DD')
            $('#timepicker').timepicker('setTime', this.nowTime())
            this.cancelTime = moment.duration(moment().format('HH:mm'))
        },
        closeCancelForm () {
            this.displayCancelForm = false
            $('#datepicker').datepicker('setDate', this.nowDate)
            this.errorMessage = null
            
        },
        cancelBooking (bookingId) {
            axios.post(`bookings/${bookingId}/cancel`, {
                cancelled_at: this.cancelDate,
                cancelled_with_comment: this.cancelledWithComment
            }).then((response) => {
                if (response.status === 202) {
                    this.cancelledBooking = moment(this.cancelDate).format('DD/MM/YYYY à HH:mm')
                    this.displayCancelForm = false
                    this.fetchBookings(this.searchFilters.agenciesID)
                }
            })
        },
        restoreBooking (bookingId) {
            axios.get(`bookings/${bookingId}/validate`).then((response) => {
                if (response.status === 202) {
                    this.cancelledBooking = 0
                    this.fetchBookings(this.searchFilters.agenciesID)
                }
            })
        },
        validateCancelDate (bookingId) {
            if (moment(this.cancelDate).isBefore(moment())) {
                this.errorMessage = null
                this.cancelBooking(bookingId)
            } else {
                this.errorMessage = 'Veuillez saisir une date/heure antérieure à la date/heure actuelle'
            }
        },
        nowTime () {
            return moment().format('HH:mm')
        },
    },
    computed: {
        ...mapState({
            bookings: state => state.bookings.bookings,
            bookings_unavailabilities: state => state.bookings.bookings_unavailabilities,
            searchFilters: state => state.bookings.searchFilters,
            userAgencies: state => state.user.agencies,
            agencies: state => state.agencies,
            me: state => state.user.me
        }),
        ...mapGetters('customers', [
            'currentCustomers',
            'selectAgenciesList',
            'userAgenciesIdList'
        ]),
        filteredBookings () {
            let filteredBookings = _.filter(this.bookings, (booking) => {
                return booking.suborder.offer.distributed_product.agency_id == _.forEach(this.searchFilters.agenciesID, (id) => {
                    return id == booking.suborder.offer.distributed_product.agency_id ? id : false
                })
            })

            return _.orderBy([...filteredBookings, ...this.bookings_unavailabilities], 'start_date')
        },
        filteredBookingsForWorkingHours () {
            return _.filter(this.bookings, (booking) => {
                return booking.suborder.offer.distributed_product.agency_id == _.forEach(this.searchFilters.agenciesID, (id) => {
                    return id == booking.suborder.offer.distributed_product.agency_id ? id : false
                })
            })
        },
        agencyFiltering () {
            return this.searchFilters.agenciesID
        },
        isRestorable () {
            if (!_.isNil(this.booking))
                return moment(this.booking.end_date).isAfter()
        },
        cancelDate () {
            let v = moment(this.cancelDay)
            return !_.isNil(this.cancelDay) && !_.isNil(this.cancelTime) ? v.add(this.cancelTime).format('YYYY-MM-DD HH:mm:ss') : null
        },
        nowDate () {
            return moment().format('DD/MM/YYYY')
        }
    },
    watch: {
        agencyFiltering(newVal, oldVal) {
            this.fetchBookings(this.searchFilters.agenciesID)
            this.fetchPunctualUnavailabiliy(this.searchFilters.agenciesID)
        }
    }
}
</script>



// WEBPACK FOOTER //
// client/components/OneTimeLocations/OneTimeLocationsUpcomingReservations.vue